import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { ScreenInformationModel } from 'src/app/model/core/screen-information';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';
import { screenActions } from 'src/app/store/screen/screen-store.action';

export abstract class BaseService {
  constructor(protected store?: Store<any>) {}

  setScreenInformation = ({
    id,
    title,
    showHeading = true,
  }: ScreenInformationModel) => {
    if (this.store) {
      this.store.dispatch(screenActions.setScreenIdAction({ id }));
      this.store.dispatch(screenActions.setScreenTitleAction({ title }));
      this.store.dispatch(
        screenActions.setScreenShowHeadingAction({ showHeading })
      );
      this.store.dispatch(
        screenActions.setScreenLoadingAction({ loading: false })
      );
    }
  };

  getScreenInformation = (): Observable<ScreenInformationModel> =>
    this.store ? this.store.select('screen', 'info') : of({});

  getShowHeading = (): Observable<boolean> =>
    this.store ? this.store.select('screen', 'showHeading') : of({});

  getUserInformation = (): Observable<SecurityUserLoginModel> =>
    this.store ? this.store.select('admin', 'user') : of({});

  getLoadingState = (): Observable<boolean> =>
    this.store ? this.store.select('screen', 'loading') : of(false);

  setLoadingState = (loading: boolean = true) => {
    if (this.store) {
      this.store.dispatch(screenActions.setScreenLoadingAction({ loading }));
    }
  };
}
